import { render } from "./complaintManagement.vue?vue&type=template&id=0bf6b75c"
import script from "./complaintManagement.vue?vue&type=script&lang=js"
export * from "./complaintManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__